import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type Account, account } from "../schemas/account";

export const getAccountProps = z
  .object({ token: z.string() })
  .extend(requestConfig.shape);

export type GetAccountProps = z.infer<typeof getAccountProps>;

export const getAccount = async (args: GetAccountProps): Promise<Account> => {
  const { endpoint = env.ACCOUNT_SERVICE_URL, token } = parseServiceInput(
    getAccountProps,
    args,
  );

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  });

  const response = await fetch(`${endpoint}/v1/account`, {
    method: "GET",
    headers,
  });

  return parseServiceOutput(response, account, {
    code: "MALFORMED_ACCOUNT",
    message: "Account is malformed",
  });
};
